module.exports = __webpack_public_path__ + "static/media/mapa-recorrido-detalle.d3ee598c.jpg";